import { useContext } from "react";
import StoreContext from "../contexts/Store/storeContext";

const useStore = () => useContext(StoreContext);

export default useStore;
